import { createContext } from 'react';

export const ChatContext = createContext(null);
export const VoiceContext = createContext(null);
